import React, { useId } from 'react';
import {
	Box,
	Chip,
	ChipProps,
	FormControl,
	FormLabel,
	RadioGroup,
} from '@mui/material';
import { useRadioGroup } from '@mui/material/RadioGroup';
import styles from './InvoiceViewGratuitySelection.module.scss';
import MuiCurrencyInput from '../../../../../mui/MuiCurrencyInput/MuiCurrencyInput';

type InvoiceViewGratuitySelectionProps = {
	gratuityAmount: number;
	setGratuityAmount: React.Dispatch<React.SetStateAction<number>>;
	setGratuitySelection: React.Dispatch<React.SetStateAction<string>>;
	gratuitySelection: string;
	validation?: string;
};

export const SELECTION_OPTIONS = {
	NONE: '0',
	PERCENT_15: '15',
	PERCENT_18: '18',
	PERCENT_20: '20',
	CUSTOM: 'Custom',
};

const GratuitySelectionLabel = ( props: ChipProps & { value: string } ) => {
	const radioGroup = useRadioGroup();
	const checked = radioGroup?.value === props.value;
	return (
		<Chip
			tabIndex={ 0 }
			size='small'
			className={ checked ? styles.checked : styles.unchecked }
			color={ checked ? 'primary' : 'default' }
			{ ...props }
			onClick={ ( e ) =>
				radioGroup?.onChange(
					{
						...e,
						target: {
							...e.target,
							value: props.value,
						},
						// shameful type casting, very bad no good
					} as unknown as React.ChangeEvent<HTMLInputElement>,
					props.value
				)
			}
		/>
	);
};

const InvoiceViewGratuitySelection = ( {
	gratuityAmount,
	setGratuityAmount,
	gratuitySelection,
	setGratuitySelection,
	validation,
}: InvoiceViewGratuitySelectionProps ) => {
	const label = 'Gratuity';
	const id = useId();
	return (
		<Box className={ styles.container } data-cy='gratuity-selection-container'>
			<FormControl>
				<FormLabel className={ styles.label }>Gratuity</FormLabel>
				<RadioGroup
					defaultValue={ SELECTION_OPTIONS.NONE }
					className={ styles.radioContainer }
					onChange={ ( e ) => setGratuitySelection( e.target.value ) }
					id={ id }
					aria-label={ label }
				>
					<GratuitySelectionLabel
						data-cy='gratuity-option-none'
						value={ SELECTION_OPTIONS.NONE }
						label='None'
					/>
					<GratuitySelectionLabel
						data-cy='gratuity-option-15'
						value={ SELECTION_OPTIONS.PERCENT_15 }
						label='15%'
					/>
					<GratuitySelectionLabel
						data-cy='gratuity-option-18'
						value={ SELECTION_OPTIONS.PERCENT_18 }
						label='18%'
					/>
					<GratuitySelectionLabel
						data-cy='gratuity-option-20'
						value={ SELECTION_OPTIONS.PERCENT_20 }
						label='20%'
					/>
					<GratuitySelectionLabel
						data-cy='gratuity-option-custom'
						value={ SELECTION_OPTIONS.CUSTOM }
						label='Custom'
					/>
				</RadioGroup>
			</FormControl>
			{ gratuitySelection !== SELECTION_OPTIONS.NONE ? (
				<MuiCurrencyInput
					value={ gratuityAmount }
					onChange={ setGratuityAmount }
					slotProps={ { htmlInput: { 'data-cy': 'invoice-gratuity-amount' } } }
					disabled={ gratuitySelection !== SELECTION_OPTIONS.CUSTOM }
					helperText={
						gratuitySelection !== SELECTION_OPTIONS.CUSTOM
							? 'Gratuity is calculated on the invoice subtotal.'
							: null
					}
					errorText={ validation }
				/>
			) : null }
		</Box>
	);
};

export default InvoiceViewGratuitySelection;
